import React from 'react'
import { mq } from 'marketing-site/src/library/utils'

import { HeroVertical } from 'marketing-site/src/mvp-v2/library/components/HeroVertical'
import { ShapeSection } from 'marketing-site/src/mvp/library/elements/ShapeSection'
import { LogoCarousel } from 'marketing-site/src/mvp-v2/library/components/LogoCarousel'
import { FeatureSpotlight } from 'marketing-site/src/mvp/library/components/FeatureSpotlight'
import { IconGrid } from 'marketing-site/src/mvp-v2/library/components/IconGrid'
import { FeatureSpotlightVertical } from 'marketing-site/src/mvp-v2/library/components/FeatureSpotlightVertical'
import { CardsWithImage } from 'marketing-site/src/mvp-v2/library/components/CardsWithImage'
import { LargeTestimonial } from 'marketing-site/src/mvp/library/components/LargeTestimonial'
import { PreFooterCTABlock } from 'marketing-site/src/mvp/library/components/PreFooterCTABlock'
import { IProductPage } from '.'

export const ProductPage = (page: IProductPage): React.ReactElement => {
  return (
    <>
      <div className="product-page" data-testid="product-page">
        {page.product.heroVertical && <HeroVertical {...page.product.heroVertical} />}
        {page.product.shapeSection && <ShapeSection {...page.product.shapeSection} />}
        {page.product.logoCarousel && <LogoCarousel {...page.product.logoCarousel} />}
        {page.product.featureSpotlightMvp && (
          <FeatureSpotlight {...page.product.featureSpotlightMvp} />
        )}
        {page.product.iconGrid && (
          <IconGrid
            {...page.product.iconGrid}
            items={page.product.iconGrid.items.map((item) => item && item)}
          />
        )}
        {page.product.featureSpotlightVerticalMVP && (
          <FeatureSpotlightVertical {...page.product.featureSpotlightVerticalMVP} />
        )}
        {page.product.cardsWithImageMVP && <CardsWithImage {...page.product.cardsWithImageMVP} />}
        {page.product.iconGridII && (
          <IconGrid
            {...page.product.iconGridII}
            items={page.product.iconGridII.items.map((item) => item && item)}
          />
        )}

        {page.product.largeTestimonialMvp && (
          <LargeTestimonial {...page.product.largeTestimonialMvp} layout="media-right" />
        )}
        {page.product.shapeSectionII && <ShapeSection {...page.product.shapeSectionII} />}
        {page.product.preFooterCTABlock && (
          <PreFooterCTABlock {...page.product.preFooterCTABlock} />
        )}
      </div>
      <style jsx>{`
        .product-page {
          :global(.feature-grid.mvp-background-color-slate) {
            padding-top: 0;
            padding-bottom: 0;
          }
          :global(.icon-grid) {
            :global(.grid-container) {
              padding-top: 3.5rem;
            }
          }
          :global(.cards-with-image) {
            :global(.static-card) {
              max-width: initial;
            }
          }

          @media (${mq.tablet}) {
            :global(.icon-grid) {
              :global(.grid-container) {
                padding-top: 5rem;
              }
            }
          }

          @media (${mq.desktop}) {
            :global(.icon-grid) {
              :global(.grid-container) {
                padding-top: 6.25rem;
              }
            }
          }
        }
      `}</style>
    </>
  )
}
